import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=5e6d5dfa"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"
import style0 from "./AddOrder.vue?vue&type=style&index=0&id=5e6d5dfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports